<div class="rg-page-header">
  <div>
    <h3 class="fw-bold mb-1">Password Reset Requests</h3>
    <p class="text-muted mb-0">
      Review and resolve admin password reset requests.
    </p>
  </div>

  <button class="btn btn-outline-secondary" (click)="loadRequests()" [disabled]="loading">
    <i class="bi bi-arrow-clockwise me-1"></i>
    Refresh
  </button>
</div>

<div class="container-fluid p-4">
  <div class="card border-0 shadow-sm rg-card">
    <div class="card-body">
      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead>
            <tr>
              <th>Email</th>
              <th>Requested At</th>
              <th>IP Address</th>
              <th>Status</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="!loading && requests.length === 0">
              <td colspan="5" class="text-center py-4 text-muted">
                No record found.
              </td>
            </tr>

            <tr *ngFor="let request of requests">
              <td>
                <div class="fw-semibold">{{ request.email }}</div>
                <small class="text-muted">{{ request.adminUserId || 'No matched admin id' }}</small>
              </td>

              <td>{{ request.requestedAt | date:'medium' }}</td>

              <td>{{ request.requestIpAddress || '—' }}</td>

              <td>
                <span class="badge text-bg-warning">Pending</span>
              </td>

              <td class="text-end">
                <button
                  class="btn btn-sm btn-outline-primary me-1"
                  (click)="openResolveModal(request)">
                  Resolve
                </button>

                <button
                  class="btn btn-sm btn-outline-danger"
                  (click)="openRejectModal(request)">
                  Reject
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="resolvePasswordRequestModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rg-modal">
      <div class="modal-header">
        <h5 class="modal-title fw-bold">Resolve Password Request</h5>
        <button type="button" class="btn-close" (click)="closeResolveModal()"></button>
      </div>

      <form (ngSubmit)="resolveRequest()">
        <div class="modal-body">
          <div class="alert alert-light border" *ngIf="selectedRequest">
            <small class="text-muted">Admin Email</small>
            <div class="fw-semibold">{{ selectedRequest.email }}</div>
          </div>

          <div *ngIf="!lastResetPassword">
            <div class="mb-3">
              <label class="form-label">New Temporary Password</label>
              <input
                type="text"
                class="form-control"
                name="newPassword"
                [(ngModel)]="resolveModel.newPassword">
            </div>

            <div class="mb-3">
              <label class="form-label">Confirm Password</label>
              <input
                type="text"
                class="form-control"
                name="confirmPassword"
                [(ngModel)]="resolveModel.confirmPassword">
            </div>

            <div>
              <label class="form-label">Resolution Note</label>
              <textarea
                class="form-control"
                rows="3"
                name="resolutionNote"
                [(ngModel)]="resolveModel.resolutionNote"></textarea>
            </div>
          </div>

          <div *ngIf="lastResetPassword" class="alert alert-success">
            <strong>Password reset successfully.</strong>

            <div class="mt-3">
              <label class="form-label">Temporary Password</label>
              <div class="input-group">
                <input class="form-control" [value]="lastResetPassword" readonly>
                <button class="btn btn-outline-secondary" type="button" (click)="copyPassword()">
                  Copy
                </button>
              </div>
            </div>

            <small class="d-block mt-2">
              Share this password with the admin user through your approved internal channel.
            </small>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="closeResolveModal()">
            Close
          </button>

          <button
            *ngIf="!lastResetPassword"
            type="submit"
            class="btn btn-primary"
            [disabled]="resolving">
            <span *ngIf="!resolving">Resolve Request</span>
            <span *ngIf="resolving">Resolving...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="rejectPasswordRequestModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rg-modal">
      <div class="modal-header">
        <h5 class="modal-title fw-bold">Reject Password Request</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <form (ngSubmit)="rejectRequest()">
        <div class="modal-body">
          <div class="alert alert-light border" *ngIf="selectedRequest">
            <small class="text-muted">Admin Email</small>
            <div class="fw-semibold">{{ selectedRequest.email }}</div>
          </div>

          <label class="form-label">Reason / Note</label>
          <textarea
            class="form-control"
            rows="3"
            name="rejectNote"
            [(ngModel)]="rejectNote"></textarea>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
            Cancel
          </button>

          <button type="submit" class="btn btn-danger" [disabled]="rejecting">
            <span *ngIf="!rejecting">Reject Request</span>
            <span *ngIf="rejecting">Rejecting...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
